/**
 * Google Ads tracking utilities
 * This file centralizes all Google Ads conversion tracking functions
 * to maintain consistency and make updates easier.
 */

/* global gtag */

/**
 * Track creator signup/registration conversion
 * Value: $5.00 USD per conversion
 */
export function trackCreatorSignup() {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/B23fCPXBmcYaEKL6qIM-',
      'value': 5.0,
      'currency': 'USD'
    });
  }
}

/**
 * Track main website page views (except creator stores)
 * Value: $0.25 USD per conversion
 */
export function trackMainWebsitePageview() {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/tsisCIS8mcYaEKL6qIM-',
      'value': 0.25,
      'currency': 'USD'
    });
  }
}

/**
 * Track creator store page views
 * Value: $0.75 USD per conversion
 */
export function trackCreatorPageView() {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/TBylCIG8mcYaEKL6qIM-',
      'value': 0.75,
      'currency': 'USD'
    });
  }
}

/**
 * Track creator signup with callback (click version)
 * This version includes a callback for navigation after tracking completes
 * Value: $5.00 USD per conversion
 */
export function trackCreatorSignupWithCallback(callback) {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/B23fCPXBmcYaEKL6qIM-',
      'value': 5.0,
      'currency': 'USD',
      'event_callback': callback
    });
    return true;
  }
  return false;
}

/**
 * Track purchases from creator stores (excluding custom products)
 * Value: $1.00 USD per conversion
 * @param {string} transactionId - Unique transaction identifier
 * @param {number} value - Purchase value (defaults to 1.0 if not provided)
 * @param {function} callback - Optional callback function to execute after tracking
 * @returns {boolean} - Returns true if tracking was successful, false otherwise
 */
export function trackCreatorPurchase(transactionId, value = 1.0, callback) {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/7afTCP67mcYaEKL6qIM-',
      'value': value,
      'currency': 'USD',
      'transaction_id': transactionId || '',
      'event_callback': callback
    });
    return true;
  }
  return false;
}

/**
 * Track begin checkout events from creator store product pages
 * Value: Not specified for this conversion action
 * @param {function} callback - Optional callback function to execute after tracking
 * @returns {boolean} - Returns true if tracking was successfully initiated, false otherwise
 */
export function trackBeginCheckout(callback) {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/5Gz6CPu7mcYaEKL6qIM-',
      'event_callback': callback
    });
    return true;
  }
  return false;
}

/**
 * Track customer purchases from creator stores
 * This is specifically for tracking customer-side purchase events
 * Value: $25.00 USD per conversion (higher value for actual purchase completion)
 * @param {string} transactionId - Unique transaction identifier
 * @param {number} value - Purchase value (defaults to 25.0 if not provided)
 * @param {function} callback - Optional callback function to execute after tracking
 * @returns {boolean} - Returns true if tracking was successful, false otherwise
 */
export function trackCustomerPurchase(transactionId, value = 25.0, callback) {
  if (window.gtag) {
    gtag('event', 'conversion', {
      'send_to': 'AW-16649960738/ln7lCIurksYaEKL6qIM-',
      'value': value,
      'currency': 'USD',
      'transaction_id': transactionId || '',
      'event_callback': callback
    });
    return true;
  }
  return false;
}